import { gql } from '@apollo/client'

export default gql`
  query mortgageWidgetPrefillSubmission($vertical: MortgageSubmissionVerticalEnum, $zipCode: String, $productTypes: [MortgageWidgetProductTypeEnum!]) {
    mortgageWidgetPrefillSubmission(vertical: $vertical, zipCode: $zipCode) {
      uuid
      ficoType
      vertical
      zipCode
      estimatedValue
      status
      downPayment
      homeValue
      loanAmount
      occupancyType
      propertyType
      products (productTypes: $productTypes){
        uuid
        externalProductId
        lender {
          name
          nmls
          slug
        }
        monthlyPayment
        loanTerm
        amortizationType
        productType
        rate
        apr
        fees
      }
    }
  }
`
